exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CueIcon-7de9d2d2{color:#757575}\n", ""]);

// Exports
exports.locals = {
	"CueIcon": "CueIcon-7de9d2d2"
};